import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchUserByID } from '../../actions';
import ShowProfile from './show-profile';

function Profile(props) {
  useEffect(() => {
    props.fetchUserByID(props.match.params.userID);
    if (props.author && props.match.params.userID === props.author.id) {
      props.history.push(`/myprofile/${props.match.params.userID}`);
    }
  }, [props.author]);

  return (
    <div id="individual-page-edit">
      <ShowProfile current={props.user} />
    </div>
  );
}

const mapStateToProps = (state, ownProps) => (
  {
    user: state.user.current,
    author: state.author.current,
  }
);
export default withRouter(connect(mapStateToProps, { fetchUserByID })(Profile));
